import dayjs from 'dayjs';
import { Timestamp } from 'firebase/firestore';

import { DAYS } from 'constants/options';
import {
  WeekType,
  ISchedule,
  IWeeklyMenu,
  FirebaseImage,
  IScheduledMenu,
} from 'types';

export const Recipe = Object.freeze({
  date: (seconds?: number, format = 'MM/DD/YYYY, HH:MM A') => {
    return seconds ? dayjs.unix(seconds).format(format) : '-/-';
  },

  avatar: (images?: FirebaseImage[]) => {
    if (images && images.length > 0) {
      return images[0].original;
    }

    return undefined;
  },

  originalUrls: (images?: FirebaseImage[]): string[] => {
    if (images) {
      return images.map((item) => item.original).filter(Boolean) as string[];
    }
    return [];
  },

  thumbnailUrls: (images?: FirebaseImage[]): string[] => {
    if (images) {
      return images.map((item) => item.thumbnail).filter(Boolean) as string[];
    }
    return [];
  },

  count: (list?: any[]): string => {
    if (list && list.length > 0) return String(list.length);
    return '-/-';
  },
});

export const Menu = Object.freeze({
  scheduleByDays: (schedule?: ISchedule): IScheduledMenu[] => {
    return DAYS.map((day) => {
      const currentSchedule = schedule ? schedule[day] : undefined;

      const currentMenu = [
        currentSchedule?.breakfast,
        currentSchedule?.dinner,
        currentSchedule?.snacks,
      ];

      const isEmptyMenu =
        currentMenu.filter((item) => !Boolean(item)).length === 3;

      return { day, menu: isEmptyMenu ? [] : currentMenu };
    });
  },

  currentWeek: (): WeekType => {
    return {
      startDate: dayjs().startOf('week').unix(),
      endDate: dayjs().endOf('week').unix(),
    };
  },

  searchParamsToWeek: (params: URLSearchParams): WeekType => {
    const startDate = params.get('startDate');
    const endDate = params.get('endDate');

    if (startDate && endDate) {
      const isValid =
        dayjs.unix(Number(startDate)).isValid() &&
        dayjs.unix(Number(endDate)).isValid();

      if (isValid) {
        return {
          startDate: dayjs.unix(Number(startDate)).unix(),
          endDate: dayjs.unix(Number(endDate)).unix(),
        };
      }
    }

    return {
      startDate: dayjs().startOf('isoWeek').local().subtract(1, 'day').unix(),
      endDate: dayjs().endOf('isoWeek').local().subtract(1, 'day').unix(),
    };
  },

  weekToDates: (week: WeekType) => {
    return {
      startDate: dayjs.unix(week.startDate),
      endDate: dayjs.unix(week.endDate),
    };
  },

  createWeekFromMenu: (menu?: IWeeklyMenu): WeekType => {
    if (menu) {
      return { startDate: menu.from.seconds, endDate: menu.to.seconds };
    }

    return Menu.currentWeek();
  },

  toTimestamp: (seconda: number) => {
    return Timestamp.fromDate(dayjs.unix(seconda).toDate());
  },
});
